import React from 'react';
import styled, { css } from 'styled-components';
import { Plane, Pos } from './Types';

type Id = {
  idx: Number;
}

type GridProps = {
  data: Plane;
  isComplete: boolean;
  onPress: (p: Pos) => () => void;
}

type CellProps = Id & {
  active: boolean;
  isComplete: boolean;
}

const Wrapper = styled.div`
  padding: 2rem;
  background: #EEE;
  box-shadow: inset 0 0 .5rem #777;
`;

const Row = styled.div<Id>`
  margin-top: ${({ idx }) => idx && '1rem'};;
  display: flex;
`;

const hoverStyle = css<CellProps>`
  :hover {
    cursor: pointer;
    background: ${({ active }) => (active ? '#F9E747' : '#C3C1B1')};
  }
`;

const activeStyle = css`
  background: #ffeb3b;
  box-shadow: inset 0 0 .4rem #777;
  transform: translateY(.4rem);
`;

const pressStyle = css`
  :active {
    ${activeStyle};
    background: #F9E747;
    box-shadow: inset 0 .1rem .4rem #777;
  }
`;

const Cell = styled.div<CellProps>`
  width: 5rem;
  height: 5rem;
  border-radius: .5rem;
  box-shadow: 0 .4rem #777;
  background: #bdbdbd;
  margin-left: ${({ idx }) => idx && '1rem'};
  ${({ active }) => active && activeStyle}
  ${({ isComplete }) => !isComplete && hoverStyle}
  ${({ isComplete }) => !isComplete && pressStyle}
`;

const Grid = ({ data, isComplete, onPress }: GridProps) => (
  <Wrapper>
    {data.map((r, ri) => (
      <Row idx={ri}>
        {r.map((c, ci) => (
          <Cell
            idx={ci}
            key={`${ri}${ci}`}
            active={c}
            onClick={onPress([ri, ci])}
            isComplete={isComplete}
          />
        ))}
      </Row>
    ))}
  </Wrapper>
);

export default Grid;
